import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core/'
import api from '../../api/stoty'
import { setStep1, setStep2, setStep3, setStep4 } from '../../modules/story/actions'
import arrowLeft from '../../assetss/img/arrowLeft.svg'
import editTitleBtn from '../../assetss/img/editTitleBtn.svg'
import editTextBtn from '../../assetss/img/editTextBtn.svg'
import editIconPrevStory from '../../assetss/img/editIconPrevStory.svg'
import './index.scss'

const PreviosStory = () => {
  const dispatch = useDispatch()
  const { story } = useSelector(state => state)
  const { idStory } = useParams()
  const [values, setValues] = useState({
    title: '',
    text: '',
    src: '',
  })
  const history = useHistory()
  const { pathname } = useLocation()
  const goTo = path => history.push(path)

  useEffect(() => {
    if (pathname === '/storyPrevios') {
      setValues({
        title: story?.step2?.title,
        text: story?.step1?.text,
        src: story?.step3?.src,
      })
    }
  }, [pathname])

  useEffect(() => {
    if (idStory) {
      api.getStorie(idStory)
        .then(res => {
          if (res?.data?.status === 'ok') {
            setValues({
              title: res?.data?.story?.title,
              text: res?.data?.story?.text,
              src: res?.data?.story?.image?.src,
            })
            dispatch(setStep1({ text: res?.data?.story?.text }))
            dispatch(setStep2({ title: res?.data?.story?.title }))
            dispatch(setStep3({ src: res?.data?.story?.image?.src, imageUuid: res?.data?.story?.image?.uuid }))
            dispatch(setStep4({ hashtags: res?.data?.story?.hashtags.toString() }))
          }
        })
    }
  }, [idStory])

  return (
    <Grid className='wrapperUserStoryEdit' container direction='column' alignItems='center'>
      <Grid
        className='headerBackgroundEdit'
        justify='center'
        container
      >
        <img className='editStoryImg' src={values?.src} />
        <Grid className='backContainerEdit' container direction='column' justify='space-between'>
          <Grid className='clickBox' container alignItems='center' onClick={() => goTo('/new-story/step/4')}>
            <img src={arrowLeft} alt='arrowLeft' />
            <Typography className='textBack'>Back</Typography>
          </Grid>
          <Grid container direction='column' className='titileContainerEdit' alignItems='center'>
            <Typography className='titileStoryEdit' align='center'>'{values?.title}'</Typography>
            <img onClick={() => goTo('/new-story/step/3')} className='editTitleBtn' src={editTitleBtn} alt='editTitleBtn' />
          </Grid>
        </Grid>
      </Grid>
      <Grid container className='storyContentEdit' wrap='nowrap'>
        <Grid className='storyTextBoxEdit' container direction='column' justify='space-between'>
          <pre className='storyTextEdit'>
            {values?.text}
          </pre>
          <Grid className='boxEditStoryBtn'>
            <img onClick={() => goTo('/new-story/step/2')} className='editStoryBtn' src={editTextBtn} alt='editTextBtn' />
            <img src={editIconPrevStory} onClick={() => goTo('/new-story/step/2')} alt='editTextBtn' className='editStoryBtnMobile' />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PreviosStory
